export default __webpack_public_path__ + "af7f080a95b6e19e55e79b402122daf4.png";